export default function()
{
    const self = this;

    self.init = () => {

        jQuery(document).ready(function() {
            jQuery(window).scroll(function () {
                jQuery('.fadeInAtFocus').each(function (i) {

                    var bottom_of_object = jQuery(this).offset().top + jQuery(this).outerHeight();
                    var bottom_of_window = jQuery(window).scrollTop() + jQuery(window).height();

                    if (bottom_of_window > bottom_of_object) {
                        jQuery(this).animate({'opacity': '1'}, 1000);
                    }
                });
            });



            var activeItem = $('.nav-primary li.active');


            function animateTo(element) {
                var $activeLi = element,
                    activeWidth = $activeLi.outerWidth(true),
                    activePositionLeft = $activeLi.position().left,
                    $border = $('.active-menu-marker'),
                    borderWidth = $border.outerWidth(true),
                    prevWidth = 0;

                $border.stop().animate({
                    left: activePositionLeft + (activeWidth / 2) - (borderWidth / 2) + ($(window).width() >= 1200 ? 9 : 0)
                });
            }



            $(function() {
                $(".nav-primary li").hover(function(e) {
                    e.preventDefault();
                    $(".nav-primary li").removeClass("hover-active");
                    $(this).addClass("hover-active");

                    animateTo($(this));
                }, function() {
                    animateTo(activeItem);
                });
            });


            setTimeout(function(){ animateTo(activeItem); }, 1000);


        });

    };
}


// WEBPACK FOOTER //
// ./scripts/animation.js